import { render } from "./LoadingComponent.vue?vue&type=template&id=15c577a8&scoped=true"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"

import "./LoadingComponent.vue?vue&type=style&index=0&id=15c577a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c577a8"]])

export default __exports__